module.exports = __webpack_public_path__ + "img/onesti-logo-branco-en.svg";